import { createFileRoute, redirect } from '@tanstack/react-router';

import { useAuth } from '@/features/auth/hooks/use-auth';
import type { User } from '@/features/auth/types/auth-types';

/**
 * Pathless layout route that ensures the user is authenticated.
 * This route narrows the auth context to guarantee that user is non-null.
 */

type AuthenticatedAuth = Omit<
  ReturnType<typeof useAuth>,
  'user' | 'isAuthenticated'
> & {
  user: User;
  isAuthenticated: true;
};

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ context }) => {
    if (!context.auth.isAuthenticated || !context.auth.user) {
      throw redirect({
        to: '/login',
        search: {
          redirectTo: window.location.href,
        },
      });
    }

    return {
      auth: {
        ...context.auth,
        user: context.auth.user,
        isAuthenticated: true as const,
      } as AuthenticatedAuth,
    };
  },
});
